module.exports = __webpack_public_path__ + "f0b24e30283d49adde14aef19c02c80b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-6.png
// module id = 2648
// module chunks = 0